(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@price-point/winston", [], factory);
	else if(typeof exports === 'object')
		exports["@price-point/winston"] = factory();
	else
		root["@price-point/winston"] = factory();
})(global, function() {
return 